import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import { connect } from 'react-redux';
import ReceivedETAModal from '../receivedETAModal';
import { updatePhaseTask, clearValidationErrors } from 'actionCreators';
import PhaseTask from './phase_task';


export class ReceivedEta extends PhaseTask {

  onClick = () => {
    if (this.props.task.status !== 'complete') this.setState({ modalActive: true });
  }

  renderChildren = () => {
    const { phase, task } = this.props;
    return (<ReceivedETAModal
      phase={phase}
      userName={name}
      task={task}
      active={this.state.modalActive}
      completeTask={this.completeTask}
      onClose={this.handleClose}
    />);
  }
}

ReceivedEta.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

const received_eta = connect(() => ({}), {
  updatePhaseTask, clearValidationErrors })(ReceivedEta);

export { received_eta };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/received_eta.jsx